var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"app"}},[_c('TilHeader'),_c('main',{staticClass:"main-content container pb-5"},[_c('transition',{attrs:{"name":"page"}},[_c('router-view')],1)],1),_c('TilFooter',{attrs:{"isShowLinks":!_vm.$route.meta.hideFooter}}),_c('MessageAlert'),_c('CookieAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }